module.exports = __webpack_public_path__ + "static/plus-cover-asset-3bc1cae9c9b69e64e7c39d8ec97c9c41.webp";